import React, { forwardRef, useImperativeHandle } from 'react';
import { Table } from '@ajaibid/components';

import AutoOrderActionProvider from '../components/AutoOrderActionProvider';
import useAutoOrder from '../hooks/useAutoOrder';
import useColumns from './hooks/useColumns';
import { styTable, styWrapper } from './style';

const StockAutoOrderMT = forwardRef((_, ref) => {
  const { data, isInitialLoading, refetch, isRefetching, fetchNextPage, isFetchingNextPage } =
    useAutoOrder({ accountType: 'MARGIN' });

  const columns = useColumns();

  useImperativeHandle(
    ref,
    () => ({
      // Allow the following functions & variables to be called from its parents
      refetchTable: refetch,
      isRefetching,
    }),
    [refetch, isRefetching]
  );

  return (
    <AutoOrderActionProvider>
      <div className={styWrapper}>
        <Table
          className={styTable}
          data={data}
          columns={columns}
          options={{ isHeaderVisible: true }}
          fetchNext={fetchNextPage}
          isInitialLoading={isInitialLoading}
          isFetchingNext={isFetchingNextPage}
          emptyStateContent="Mulai bertransaksi dan lihat statusnya di sini."
        />
      </div>
    </AutoOrderActionProvider>
  );
});

export default StockAutoOrderMT;
